import React, { createContext, FC, useState } from 'react'
import { Popover } from '@mui/material'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import IconButton from '@mui/material/IconButton'
import { ReactComponent as TrashSvg } from '../../../../../../../assets/trash.svg'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

interface ScheduleOptionsPopoverProps {
	id: string
	entityName: string
	onDelete: (id: string) => Promise<void> | void
	container?: Element | (() => Element | null) | null | undefined
	editSlot?: React.ReactNode
}

export interface CreateScheduleOptionsContext {
	setPopoverAnchor: React.Dispatch<HTMLButtonElement | null> | null
}

export const CreateContextScheduleOptions =
	createContext<CreateScheduleOptionsContext>({
		setPopoverAnchor: null,
	})

const ScheduleOptionsPopover: FC<ScheduleOptionsPopoverProps> = ({
	id,
	onDelete,
	entityName,
	container,
	editSlot,
}: ScheduleOptionsPopoverProps) => {
	const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)

	const handleClickMoreOptions: React.MouseEventHandler<
		HTMLButtonElement
	> = event => {
		event.stopPropagation()
		setAnchorEl(event.currentTarget)
	}

	const handleClose: React.MouseEventHandler<HTMLButtonElement> = event => {
		event.stopPropagation()
		setAnchorEl(null)
	}

	const handleClickDelete: React.MouseEventHandler<
		HTMLButtonElement
	> = () => {
		setAnchorEl(null)
		onDelete(id)
	}

	const open = !!anchorEl

	const popoverId = open ? `${entityName}-${id}` : undefined

	return (
		<CreateContextScheduleOptions.Provider
			value={{ setPopoverAnchor: setAnchorEl }}
		>
			<IconButton
				aria-describedby={popoverId}
				onClick={handleClickMoreOptions}
				sx={{ padding: 1 }}
				aria-label={'Open options'}
			>
				<MoreVertIcon />
			</IconButton>

			<Popover
				id={popoverId}
				container={container}
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
				sx={{
					'.MuiPaper-elevation': {
						borderRadius: '10px!important',
					},
				}}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'right',
				}}
				transformOrigin={{ vertical: 'top', horizontal: 'right' }}
			>
				<Box
					py={2}
					px={1}
					display={'flex'}
					flexDirection={'column'}
					alignItems={'flex-start'}
				>
					{editSlot}

					<Button
						startIcon={<TrashSvg />}
						size={'large'}
						sx={{ justifyContent: 'flex-start', width: '7.5rem' }}
						onClick={handleClickDelete}
						aria-label={'Delete'}
					>
						<Typography fontFamily={'Gilroy-SemiBold, sans-serif'}>
							Delete
						</Typography>
					</Button>
				</Box>
			</Popover>
		</CreateContextScheduleOptions.Provider>
	)
}

export default ScheduleOptionsPopover
